module.exports = "/assets/data/a265aaf0ab82d4c0cfc94de7c6d2dcd8-IG2.data.json";